import Vue from 'vue/dist/vue.esm.js'

KCVS.Views.ReportFileGroupPagination = Vue.extend(
  template: JST['report_file_groups/report_file_group_pagination']()
  name: 'GroupPagination'
  props: ['groupPages', 'group']
  data: ->
    currentPage: @groupPages.currentPage
    totalPages: @groupPages.totalPages

  watch:
    groupPages: (newVal) ->
      @currentPage = newVal.currentPage
      @totalPages = newVal.totalPages

  methods:
    goToPage: (page) ->
      if page >= 1 && page <= @totalPages
        @$emit('page-changed', { groupId: @group.id, page: page })
)